import { Component, Optional, Input,EventEmitter,Output,ViewChild, ViewEncapsulation, ElementRef, OnInit } from "@angular/core";
import { NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from '../../core/auth-service.component';
import {MessageBox} from '../../commoncomponent/MessageBox/MessageBox';
import { HttpResponse, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { EnvService } from "src/app/core/env.service";

@Component({
    selector: "app-modal",
    styleUrls: ['../rule.scss'],
    templateUrl: "./attachDocument.component.html",
    encapsulation: ViewEncapsulation.None
})
export class AttachDocumentModalComponent implements OnInit{
  
  uploadSaveUrl:any; 
  uploadRemoveUrl = 'removeUrl'; 
  message: string;
  style: string;
  public progress: number;
  public invdata:Array<any> = [];
  public invs:Array<any> = [];
  public fFile = [];
  public fileAttachment:Array<any>= [];
  public invIds:any;
  public fileCount = 0;
  @Input() public myFiles:string [] = [];
  @ViewChild('attachments',{static: false}) attachment: any;
  @ViewChild('pBar', {static: false}) pBar: ElementRef;
  @ViewChild('msg', {static: false}) msg: ElementRef;
  @ViewChild('mdi', {static: false}) mdi: ElementRef;
  @ViewChild('clrFile', {static: false}) clrFile: ElementRef;
  @ViewChild('progressCount', {static: false}) progressCount: ElementRef;
  @Input() public clCode: any;

  constructor(private _authService: AuthService,public _env: EnvService,
              @Optional() private readonly activeModal: NgbActiveModal,private _messageBox:MessageBox) { }

  ngOnInit() {
    console.log(this.clCode);
    this.uploadSaveUrl = this._env.apiRule +'Coding/ImportRulesFIles?clientCode=' + this.clCode;
  }
  public onSelectEvent(e) {
    this.fileCount += 1;

    console.log(e);
  }
  public getFileDetails (e) {
      var files = "";
      let scope = this
      for (var i = 0; i < e.target.files.length; i++) { 
          //to do: split all specaill character to get actual filename of the image
          var sFile = e.target.files[i].name;
          var d = sFile.split("_");
          var z = d.join("");
          scope.fFile = scope.fileAttachment.map(function(o) {return o.RawFileName});
          let y = scope.fFile.indexOf(z);
          if(y === -1)
          {
            this.myFiles.push(e.target.files[i]);
            files = files + e.target.files[i] 
          }
          else
          {
            this._messageBox.open("File already exists");
            this.clrFile.nativeElement.value = null;
          }
        }

        this.invs.forEach(function (invoice) {  
            for (var i = 0; i < e.target.files.length; i++) { 
              var attachment = <any>{};
              attachment.InvoiceId = invoice.Id;
              attachment.RawFileName = e.target.files[i].name;
              this.fileAttachment.push(attachment);
            }
          });  
          this.attachment.nativeElement.value = '';
    }
  public removeSelectedFile(invoiceAttachment) {
    // this._webResService.removeFile(invoiceAttachment.InvoiceId,invoiceAttachment.RawFileName).subscribe((data) => { });
    //   this.fileAttachment  =  this.fileAttachment.filter(function(inv){
    //   return inv.RawFileName != invoiceAttachment.RawFileName
    // });
  }

  public uploadFile(){
    if(this.clrFile.nativeElement.value === null || this.clrFile.nativeElement.value === "")
    {
      this._messageBox.open("Please attach file first")
    }
    else{
      var formData = new FormData();
      for(let i =0; i < this.myFiles.length; i++){
      formData.append("files", this.myFiles[i], this.myFiles[i]['name']);
      }
      this.pBar.nativeElement.innerHTML = '0%';
      this.progress = 0;
      const ids = this.invs.map(inv => inv.Id);
      var commaSeparatedIDs = ids.join();
      this._authService.getAccessToken().then(token =>{
      // this._webResService.uploadFile(commaSeparatedIDs,formData,token).subscribe(event => {
      //     return event;
      //  }, error => {
      //   console.log(error);
      //   });
      })
    }
  }
  
  public dismiss(): void {
      if (this.activeModal)
        this.activeModal.dismiss();
  }
} 
